import React from 'react';
import RenderMainPage from "./RenderMainPage";
import Footer from "./Footer";

function App() {
    return (
        <div>
            <RenderMainPage />
            <Footer />
        </div>
    );
}

export default App;
